export default "__VITE_ASSET__BTy1AQDh__"